import { z } from 'zod';
import { NEWLY_BUILT_CATEGORY_TYPE } from './constants';

export const zengaResponseSchema = z
	.array(
		z
			.object({
				advertId: z.number(),
				address: z.string(),
				propertyCategory: z.string(),
				picture: z.string().url(),
				urlSlug: z.string(),
				advertTitle: z.string().optional(),
				price: z.number().optional(),
				newlyBuiltProjectSummary: z
					.object({
						projectName: z.string(),
						priceMin: z.number(),
						priceMax: z.number()
					})
					.optional()
					.nullable()
			})
			.refine(
				(item) => {
					if (item.propertyCategory === NEWLY_BUILT_CATEGORY_TYPE) {
						return !!item.newlyBuiltProjectSummary.projectName;
					} else {
						return !!item.advertTitle;
					}
				},
				{
					message: 'Expected projectName or advertTitle to be defined',
					params: ['newlyBuiltProjectSummary.projectName', 'advertTitle']
				}
			)
			.refine(
				(item) => {
					if (item.propertyCategory === NEWLY_BUILT_CATEGORY_TYPE) {
						return !!item.newlyBuiltProjectSummary.priceMin && !!item.newlyBuiltProjectSummary.priceMax;
					} else {
						return true;
					}
				},
				{
					message: 'Expected priceMin and priceMax to be defined when category is newly built',
					params: ['newlyBuiltProjectSummary.priceMin', 'newlyBuiltProjectSummary.priceMax']
				}
			)
			.refine(
				(item) => {
					if (item.propertyCategory !== NEWLY_BUILT_CATEGORY_TYPE) {
						return !!item.price;
					} else {
						return true;
					}
				},
				{
					message: 'Expected price to be defined when category is not newly built',
					params: ['price']
				}
			)
	)
	.min(3);
